import React from "react";
import Header from "../component/Header";
import Background from "../assets/Images/board.jpg";
import FooterComponent from "../component/Footer";

function TermAndConditions() {
  return (
    <div>
      <div
        className="h-72 relative px-24 after:absolute after:bg-black after:z-10 after:top-0 after:left-0 after:w-full after:h-full after:opacity-55"
        style={{
          background: `url(${Background})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <Header lightMode={true}/>
        <h2 className="text-4xl absolute z-20 top-1/2 left-1/2 text-white font-semibold">
          Terms & Conditions
        </h2>
      </div>
      <div className="w-3/4 mx-auto mb-20">
        <h2 className="text-3xl font-semibold mt-6">
          General Terms of Service
        </h2>
        <h4>Prologue to eJobs Terms and Services</h4>
        <p>
          {" "}
          Each time you access or utilize ejobs on the web and additionally
          versatile administrations and sites, including yet not restricted to
          any Indeed portable application and program augmentation or module (on
          the whole the "Without a doubt Apps"), paying little mind to where it
          is downloaded from, and any product, administration, highlight, item,
          program and component gave by or for Indeed on or regarding such
          administrations or sites (all in all, the "Webpage"), including, yet
          not restricted to, any items, projects, and administrations depicted
          in these Terms of Service, (a) you represent that you have perused and
          get the Cookie Policy and Privacy Policy; and (b) you are consenting
          to the agreements of these Terms of Service (the "Understanding")
          then, at that point, basically with the accompanying substance or
          elements: Below you will observe eJobs agreements, including our treat
          and privacy policies. We realize we are giving a lot of data. eJobs
          does this on purpose: we need you to have as much information about
          how we help you at eJobs as is conceivable. We don't need you to
          ponder any of our procedures or methods or surmise concerning what
          your cooperation with eJobs implies. We need you to comprehend it,
          which is the reason we should clarify it exhaustively. We encourage
          you to peruse these terms or any part important to you. You are
          consenting to continue under them.
        </p>
        <h3 className="text-lg mt-4">
          {" "}
          Terms of Service for Job Seekers, Vacancy Ads or Job Listings
        </h3>
        <p>
          {" "}
          The following terms and conditions apply if you access our services,
          eJobs make accessible Job Ads publicizing business open doors and
          other occupation related content, including connections to outsider
          sites ("Job Listings" or "Occupation Adverts"), through eJobs query
          items or in any case through the Site. Looking for Job Ads on Indeed
          is free for Job Seekers.
          <br />
          Work Ads are made and given by outsiders over whom eJobs practices no
          control; you recognize and comprehend that eJobs has zero command over
          the substance of Job Ads, connections to or from Job Ads, or any
          circumstances third parties could force once a Job Seeker has
          presented an application or left the Site. For instance, a portion of
          these outsiders might endeavor to charge Job Seekers an expense to
          apply to a specific work, albeit eJobs tries not to make such Job Ads
          accessible on the Site
        </p>
        <div>
          <h2 className="text-2xl font-semibold mt-4 mb-2"> Acknowledgment</h2>
          <p>
            Assuming you leave the eJob Site and decide to enter an third party
            site, you acknowledge any agreements forced by that third party.
            Manager sites might have change trackers or use APIs and other
            usefulness given by ejJobs, which illuminates us that an application
            has been finished on an Employer site. An Employer who introduces
            such usefulness is expected under this Agreement to give any
            notification, and acquire any earlier assent, that might be expected
            by relevant regulation. Notwithstanding, you recognize and concur
            that eJobs has zero power over such an Employer or its site. You
            consent to eJobs utilization of, and receipt of data from, any such
            transformation tracker usefulness. With the exception of supported,
            highlighted or paid arrangements, the Job Ads contained on, or
            connected from, the Site are listed or posted in a robotized way,
            And as such, as not incorporate any Job Ads, in its indexed lists or
            different postings, and may bar or eliminate any Job Ads from the
            Site or your query output with practically no commitment to give
            thinking to evacuation or rejection. You get it and concur that
            eJobs has no commitment to give you any or all Job Ads.
          </p>
        </div>
        <div>
          <h2 className="text-2xl font-semibold mt-4 mb-2"> Verification</h2>
          <p>
            At eJobs we try to verify the authentication of documents submitted
            but we can't affirm the precision or fulfillment of any Job Ad or
            other data presented by any Employer or other client, including the
            personality of such Employer or other client. Without a doubt
            embraces no obligation, and disavows all risk for the substance,
            precision, fulfillment, lawfulness, dependability, or accessibility
            of any Job Ads, Company Pages, screener questions and reactions, and
            evaluations. Also, eJobs might give search choices to limit Job Ads
            query items by work type classifications (for example full-time,
            part time, and so on), and such classifications are made
            autonomously and totally by eJobs, and may not straightforwardly or
            precisely mirror the substance of the Job Ads. To be sure may
            reformat Job Listings so you might peruse them all the more
            obviously on a cell phone. While eJobs may in certain conditions be
            remunerated by businesses who post Job Ads, assisting keep
            with/without a doubt jobbing scan free for Job Seekers, all Job Ads
            are viewed as promoting. Without a doubt shows Job Ads in light of a
            mix of remuneration paid by bosses to eJobs and significance, for
            example, search terms, and other data gave and exercises directed on
            eJobs.
          </p>
        </div>
        <div>
          <h2 className="text-2xl font-semibold mt-4 mb-2">
            {" "}
            Use of eJobs Content
          </h2>
          <p>
            You are not allowed to utilize eJobs Site or its substance other
            than for non-business purposes. For motivations behind this Section
            and any of the E-Jobs General Terms of Service, all references to
            "you" or "your" will mean you, the individual or association getting
            to this Site in your ability as a Job Seeker. For sure may give
            usefulness to call a phone number contained in a Job Ad utilizing
            the telephone application on a cell phone. Without a doubt can't
            ensure that the separated telephone number is the right telephone
            number for the Employer or for the Job Ad you are seeing, and at
            interview meet in person the up-loader of the job Ads.
          </p>
        </div>
        <div>
          <h2 className="text-2xl font-semibold mt-4 mb-2">
            {" "}
            Blacklist following Encroachment of The Copyright, Safety Or Other
            Licensed innovation Freedoms Of Others
          </h2>
          <p>
            {" "}
            e-Jobs regards the licensed innovation of others, and we ask our
            Clients and content accomplices to do likewise. The unapproved
            posting, propagation, duplicating, circulation, alteration, public
            presentation or public execution of protected works comprises
            encroachment of the copyright proprietors freedoms. As a condition
            to Your utilization of the e-Jobs Destinations, You make a deal to
            avoid utilizing any e-Jobs site to encroach the protected innovation
            freedoms of others in any capacity. e-Jobs maintains all authority
            to end the records of any Clients, and square admittance to the
            e-Jobs Destinations of any Clients who are accounted for to have
            encroach the copyrights, or other protected innovation privileges,
            of others. e-Jobs saves the right, in its only carefulness, to make
            these moves to restrict admittance to the Site or potentially end
            the records of any time, in our only watchfulness Clients who
            encroach any licensed innovation freedoms of others, regardless of
            whether there is any recurrent encroachment, regardless of notice,
            and with practically no risk to the Client who is ended or to the
            Client whose entrance is impeded. Despite the prior, if you have
            confidence sincerely that a notification of copyright encroachment
            has been wrongly recorded against you. You can contact our help
            group
          </p>
        </div>
        <div>
          <h2 className="text-2xl font-semibold mt-4 mb-2">
            {" "}
            Terms and Condition For Jobseekers Allowance
          </h2>
          <p>
            The job seeker’s allowance is a stipend payment given/meant for
            transporting a job seeker to locations of vacancy and also for minor
            upkeep pending employment. Thus, by applying for the job seekers
            allowance you consent to the terms and policies of eJobs and will
            comply by the rules of engagement
            <ul>
              <li>You are a job seeker (someone willing and ready to work)</li>
              <li>
                As a job seeker you shall be send to client companies or
                organization for duties at intervals within the week
              </li>
              <li>
                Job seeker shall be given the stipend (allowance) to aid them
                transport themselves for job vacancies
              </li>
              However, the paid stipends shall be afterward deducted
              instalmentally from job seeker salary (after he/she has secured
              employment).
            </ul>
          </p>
        </div>
      </div>
      <FooterComponent/>
    </div>
  );
}

export default TermAndConditions;
